"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var on_change_1 = require("on-change");
var yup = require("yup");
var axios_1 = require("axios");
require("bootstrap");
var view_1 = require("./view");
var parser_1 = require("./parser");
var normalizeData_1 = require("./normalizeData");
var i18n_1 = require("./i18n");
var postsCheckInterval = 5000;
var getAddedLinks = function (feeds) { return feeds.map(function (feed) { return feed.link; }); };
var genUrl = function (address) {
    var url = new URL('/get', 'https://allorigins.hexlet.app');
    url.searchParams.set('disableCache', 'true');
    url.searchParams.set('url', address);
    return url.toString();
};
var checkNewPosts = function (state, period) {
    if (period === void 0) { period = postsCheckInterval; }
    var addedLinks = getAddedLinks(state.feedsData.feeds);
    var promises = addedLinks.map(function (link) { return axios_1.default.get(genUrl(link))
        .then(function (response) {
        var contents = response.data.contents;
        var parsedData = (0, parser_1.default)(contents);
        var newPosts = (0, normalizeData_1.getNewPosts)(parsedData.posts, state.feedsData.posts);
        state.feedsData.posts = __spreadArray(__spreadArray([], newPosts, true), state.feedsData.posts, true);
    }); });
    Promise.all(promises).finally(function () {
        setTimeout(function () { return checkNewPosts(state); }, period);
    });
};
var handleErrors = function (error, state) {
    if (error.name === 'ValidationError') {
        var key = error.message.key;
        state.error = key;
        return;
    }
    if (error.message === 'parsingFailed') {
        state.error = 'parsingFailed';
        state.processState = 'filling';
        return;
    }
    if (error.response) {
        state.error = 'networkError';
        state.processState = 'filling';
        return;
    }
    if (error.code === 'ECONNABORTED') {
        state.error = 'networkAborted';
        state.processState = 'filling';
        return;
    }
    state.error = 'unknownError';
};
exports.default = (function () {
    yup.setLocale({
        mixed: {
            notOneOf: function () { return ({ key: 'notOneOf' }); },
            required: function () { return ({ key: 'required' }); },
        },
        string: {
            url: function () { return ({ key: 'url' }); },
        },
    });
    var baseSchema = yup.string().url().required();
    var elements = {
        form: document.getElementById('rss-form'),
        url: document.getElementById('url-input'),
        submit: document.querySelector('button[type="submit"]'),
        feeds: document.querySelector('.feeds'),
        posts: document.querySelector('.posts'),
        feedback: document.querySelector('.feedback'),
        modal: document.getElementById('modal'),
    };
    var state = (0, on_change_1.default)({
        processState: 'filling',
        url: '',
        error: null,
        feedsData: {
            feeds: [],
            posts: [],
        },
        uiState: {
            viewedPostsIds: new Set(),
            openedModalId: null,
        },
    }, function (path, value) { return (0, view_1.default)(state, elements, i18n_1.default, path, value); });
    var validate = function (currentUrl, urls) {
        var schema = baseSchema.notOneOf(urls);
        return schema.validate(currentUrl);
    };
    elements.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(e.target);
        state.url = formData.get('url').toString();
        var addedLinks = getAddedLinks(state.feedsData.feeds);
        validate(state.url, addedLinks)
            .then(function () {
            state.processState = 'sending';
            return axios_1.default.get(genUrl(state.url), { timeout: 30000 });
        })
            .then(function (_a) {
            var data = _a.data;
            var parsedData = (0, parser_1.default)(data.contents);
            var feeds = (0, normalizeData_1.addNewFeed)(parsedData, state.feedsData, state.url);
            state.feedsData = feeds;
            state.processState = 'loaded';
        })
            .catch(function (error) {
            handleErrors(error, state);
            throw new Error(error);
        });
    });
    elements.posts.addEventListener('click', function (e) {
        var targetEl = e.target;
        var postId = targetEl.dataset.id;
        if (postId) {
            state.uiState.viewedPostsIds.add(postId);
        }
        if (targetEl.hasAttribute('data-bs-toggle')) {
            e.preventDefault();
            state.uiState.openedModalId = postId;
        }
    });
    setTimeout(function () { return checkNewPosts(state); }, postsCheckInterval);
});
